/**
 * Automatically imports all the modules and default states
 * and exports as a single object
 */
const requireModule = require.context('.', true, /index\.js$/);
const modules = {};
const defaultState = {};

requireModule.keys().forEach((fileName) => {
  if (fileName === './index.js') { return; }
  const moduleName = fileName.replace(/(\.\/|index\.js|\/)/g, '');
  const module = requireModule(fileName);
  if ('store' in module) {
    modules[moduleName] = module.store;
  } else if (moduleName in module) {
    modules[moduleName] = module[moduleName];
  } else {
    return;
  }
  defaultState[moduleName] = module.defaultState();
});

export { modules, defaultState };
